import { internal, template } from '../../../vendor/elix.js';

function ButtonTextMixin(Base) {

  return class ButtonText extends Base {

      get [internal.template]() {

        return template.concat(

          super[internal.template],

          template.html`
            <style>

              :host {
                --tp-ripple-mixin-background-color: var(--tp-button-text-mixin-ripple-color);
              }

              #inner {
                background-color: var(--tp-button-text-mixin-background-color);
                color: var(--tp-button-text-mixin-font-color);
              }

              #inner[disabled], #inner:disabled {
                background-color: var(--tp-button-text-mixin-background-color-disabled);
              }

              #inner:hover:enabled,
              #inner:active:enabled,
              :host(:focus) #inner:enabled {
                background-color: var(--tp-button-text-mixin-background-color-active);
              }
            </style>
          `
        );
      }
    }
  }

export default ButtonTextMixin;
